import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    content: 'px-3 sm:px-27.5'
  },
  variants: {
    step: {
      code: {
        content: 'max-sm:pt-2!'
      },
      registration: {
        content: 'max-sm:pt-16!'
      },
      login: {
        content: 'max-sm:pt-16!'
      }
    }
  }
});
